export function endSentenceWithDot(text: string) {
  return text.replace(/\s*\.?\s*$/, "") + ".";
}
